var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDdxAudioResume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FDF7D7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_638_39139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.625 16V11.5C12.625 10.6049 12.9806 9.74645 13.6135 9.11351C14.2464 8.48058 15.1049 8.125 16 8.125C16.8951 8.125 17.7536 8.48058 18.3865 9.11351C19.0194 9.74645 19.375 10.6049 19.375 11.5V16C19.375 16.8951 19.0194 17.7536 18.3865 18.3865C17.7536 19.0194 16.8951 19.375 16 19.375C15.1049 19.375 14.2464 19.0194 13.6135 18.3865C12.9806 17.7536 12.625 16.8951 12.625 16ZM21.625 16C21.625 15.8508 21.5657 15.7077 21.4602 15.6023C21.3548 15.4968 21.2117 15.4375 21.0625 15.4375C20.9133 15.4375 20.7702 15.4968 20.6648 15.6023C20.5593 15.7077 20.5 15.8508 20.5 16C20.5 17.1935 20.0259 18.3381 19.182 19.182C18.3381 20.0259 17.1935 20.5 16 20.5C14.8065 20.5 13.6619 20.0259 12.818 19.182C11.9741 18.3381 11.5 17.1935 11.5 16C11.5 15.8508 11.4407 15.7077 11.3352 15.6023C11.2298 15.4968 11.0867 15.4375 10.9375 15.4375C10.7883 15.4375 10.6452 15.4968 10.5398 15.6023C10.4343 15.7077 10.375 15.8508 10.375 16C10.3767 17.394 10.8953 18.7378 11.8304 19.7716C12.7655 20.8054 14.0507 21.4558 15.4375 21.5969V23.875C15.4375 24.0242 15.4968 24.1673 15.6023 24.2727C15.7077 24.3782 15.8508 24.4375 16 24.4375C16.1492 24.4375 16.2923 24.3782 16.3977 24.2727C16.5032 24.1673 16.5625 24.0242 16.5625 23.875V21.5969C17.9493 21.4558 19.2345 20.8054 20.1696 19.7716C21.1047 18.7378 21.6233 17.394 21.625 16Z",
    fill: "#ED8A00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_638_39139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDdxAudioResume);
export default __webpack_public_path__ + "static/media/ddx-audio-resume.fe55d4ed04519df075fd1e38b694a861.svg";
export { ForwardRef as ReactComponent };